import React, { useEffect } from 'react';
import { bool, string, func } from "prop-types";
import { createPortal } from 'react-dom';
import { FileUploadMultiple, Button, Loading } from '@Components';
import userAuth from "@Config/userauth";
import { apiPost } from '@Shared/Api/apiClient';
import { APPCONFIG } from '@/app.config';
import './styles.scss';


class UploadFileRepository extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loadingForm: false,
      error: null,
      showModal: false,
      portalElement: null
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResponse = this.handleResponse.bind(this);

    this.refFileUploadMultiple = React.createRef();
  }

  componentDidMount() {
    const portalElement = document.createElement('div');
    portalElement.setAttribute('id', 'upload-file-repository-portal');
    document.body.appendChild(portalElement);
    this.setState({ portalElement });
  }

  componentWillUnmount() {
    if (this.state.portalElement && this.state.portalElement.parentNode) {
      this.state.portalElement.parentNode.removeChild(this.state.portalElement);
    }
  }

  handleShowBody() {
    this.setState({ showModal: true });
  }

  handleHideBody() {
    this.setState({ showModal: false });
  }



  handleSubmit() {
    const files = this.refFileUploadMultiple.current.getFiles();

    if (!files || files.length === 0) {
      this.setState({ error: 'Debe seleccionar al menos un archivo' });
      return;
    }

    const listaFileName = files.map(f => f.name);

    // Convertir archivos a base64
    const readFileAsBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };

    const convertFilesToBase64 = async () => {
      try {
        const base64Files = await Promise.all(
          files.map(f => readFileAsBase64(f.file))
        );

        this.setState({ loadingForm: true, error: null }, () => {
          apiPost(APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/FileRepository/Upload', {
            'Entity': this.props.entity,
            'EntityId': this.props.entityId,
            'FileName': listaFileName,
            'File': base64Files,
            'User': userAuth.userId()
          }, true)
            .then(this.handleResponse)
            .catch(error => {
              this.setState({ loadingForm: false, error: 'Error al subir los archivos' });
            });
        });
      } catch (error) {
        this.setState({ error: 'Error al leer los archivos' });
      }
    };

    convertFilesToBase64();
  }

  handleResponse = response => {
    if (response.success) {
      this.setState({ loadingForm: false, error: null, showModal: false }, () => {
        if (this.props.callbackDone !== null) {
          this.props.callbackDone();
        }
      });
    }
    else {
      this.setState({ loadingForm: false, error: response.businessExceptions.map(x => x.message).join(". ") });
    }
  }

  render() {
    const modalContent = this.state.showModal ? (
      <div className="modal show d-block" tabIndex="-1" role="dialog" aria-modal="true" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" aria-hidden="true" onClick={() => this.handleHideBody()}>x</button>
              <h4 className="modal-title text-center">Subir archivos</h4>
            </div>
            <div className="modal-body">
              <div className='col-md-12 text-center'>
                <FileUploadMultiple ref={this.refFileUploadMultiple} multiple={this.props.multiple} />
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-12">
                <Button type="submit" size="medium-lg" onClick={this.handleSubmit}>Aceptar</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;

    return (
      <>
        <Loading visible={this.state.loadingForm}></Loading>
        {this.state.portalElement && createPortal(modalContent, this.state.portalElement)}
        <Button type="button" size="medium-lg" fill="outline" onClick={() => { this.handleShowBody() }}>Subir archivos</Button>
      </>
    );

  }

}

UploadFileRepository.propTypes = {
  entity: string,
  entityId: string,
  multiple: bool,
  callbackDone: func
}

UploadFileRepository.defaultProps = {
  entity: '',
  entityId: '',
  multiple: true,
  callbackDone: null
}

export default UploadFileRepository;
